import { FuelTransaction } from '@/src/types/FuelTransaction';
import { faTag } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext, useState } from 'react';
import { useFuelTransaction } from '../hooks/useFuelTransaction';
import { Dialog } from '../../ui/Dialog';
import { getFormattedDate } from '../../../lib/dateUtils';
import { toast } from 'react-toastify';
import { UserContext } from '../../../context/UserProvider';
import { Button } from '../../ui/Button';

export const UnMarkFuelTransactionAsSubtituteCarUsage = ({ fuelTransaction }: { fuelTransaction: FuelTransaction }) => {
    const { userRole } = useContext(UserContext);
    const [isOpen, setIsOpen] = useState(false);
    const unMarkAsSubstituteCarUsage = useFuelTransaction().unMarkAsSubstituteCarUsage();

    const handleMarkAsNormalUsage = (fuelTransaction: FuelTransaction) => {
        unMarkAsSubstituteCarUsage.mutate(fuelTransaction.id, {
            onSuccess: () => {
                setIsOpen(false);

                toast('Tankbeurt succesvol als normaal vervoer gemarkeerd.');
            },
            onError: () => {
                toast.error('Tankbeurt kon niet als normaal vervoer gemarkeerd worden. Probeer het later nog eens.');
            }
        });
    };

    return (
        <>
            <Button.Icon onClick={() => setIsOpen(true)} aria-label="set as normal car usage" title="Markeer als normaal vervoer">
                <FontAwesomeIcon icon={faTag} className="text-lg" />
            </Button.Icon>

            <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
                <>
                    <Dialog.Title>Markeren als normaal vervoer</Dialog.Title>
                    <div className="my-4">
                        Weet je zeker dat je de tankbeurt op <b>{`${getFormattedDate(fuelTransaction.transactionDate)}`}</b> wilt markeren als normaal vervoer?
                    </div>
                    <div className="flex justify-end">
                        <Button onClick={() => handleMarkAsNormalUsage(fuelTransaction)} loading={unMarkAsSubstituteCarUsage.isPending}>
                            Markeren
                        </Button>
                    </div>
                </>
            </Dialog>
        </>
    );
};
